import { useCallback } from 'react';

// hooks
import { FieldRenderProps } from 'react-final-form';

// components
import MentionsTextField from './MentionsTextField';

interface Props extends FieldRenderProps<string, HTMLElement> {
  label: string;
  maxLength?: number;
}

export default function MentionsFormTextField({
  input,
  meta,
  label,
  maxLength,
  ...rest
}: Props) {
  const handleChange = useCallback(
    (_event: { target: { value: string } }, newValue: string) => {
      input.onChange(newValue);
    },
    [input]
  );

  return (
    <MentionsTextField
      label={label}
      maxLength={maxLength}
      name={input.name}
      value={input.value}
      onChange={handleChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      {...rest}
    />
  );
}
